import { catchError } from '@/shared/application/services/catchErrorService';
import { trackingService } from '@/shared/application/services/TrackingService';
import { Actions, Categories, EventName, Labels } from '@/shared/domain/enums';
import { getDecodedSession } from '@/shared/infrastructure/adapters/storage';
import { partner } from '@/shared/infrastructure/clients';
import { getAttendances } from '@/utils/getAttendances';

type CurrentSession = {
  userId: string;
  source: string;
  email: string;
  domain: string;
  type: string;
  name: string;
  products: string;
  socialName: string;
  cnpj: string;
  document?: string;
  phone?: string;
};

const currentSession = async (): Promise<CurrentSession> => {
  const dispatch = trackingService();
  const categories = [Categories.Partnerships, Categories.Authentication, Categories.Login];

  try {
    dispatch({
      event: EventName.Partners,
      category: categories,
      action: ['partner account', Actions.Submit],
    });
    const response = await partner().getCurrentAccount();
    dispatch({
      event: EventName.Partners,
      category: categories,
      action: ['partner account', Actions.Submit, Labels.Success],
    });

    const decodedSession = await getDecodedSession();
    const phone = response.data.phone && {
      phone: `${response.data.phone.code}${response.data.phone.number}`,
    };
    const document = response.data.document && {
      document: response.data.document.code,
    };

    return await Promise.resolve({
      userId: decodedSession.userId,
      email: decodedSession.username,
      domain: decodedSession.username.split('@').pop(),
      source: response.data.branch.source?.toUpperCase(),
      type: response.data.type,
      name: response.data.name,
      cnpj: response.data.branch.cnpj,
      socialName: response.data.branch.unitName,
      products: getAttendances(response.data.branch.attendances),
      ...phone,
      ...document,
    });
  } catch (error: any) {
    catchError({
      error,
      onRequestError: (err) => {
        dispatch({
          event: EventName.Partners,
          category: categories,
          action: ['partner account', Actions.Submit, Labels.Error],
          label: err?.response?.data,
        });
      },
    });

    return Promise.reject(error);
  }
};

export { currentSession };
